import { bounceLine } from "./rule";

/** The bounce row under a reason that did not read as one: the same words on a desk and on a card, with the one way out. */
export function RationaleBounce({ reason, onSendAsIs, testId, busy = false }: { readonly reason?: string | undefined; readonly onSendAsIs: () => void; readonly testId: string; readonly busy?: boolean }) {
  return (
    <div className="gx-decide-bounce" role="status" data-testid={testId}>
      <span>{bounceLine(reason)}</span>
      <button type="button" className="gx-btn gx-btn--secondary" disabled={busy} onClick={onSendAsIs}>Send as is</button>
    </div>
  );
}
